export default __webpack_public_path__ + "static/media/portfolio.0b6cbe45.svg";